module.exports = __webpack_public_path__ + "img/marker-map.6a0067d5.png";